<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import LoginView from '../../auth/components/LoginView.vue'

definePage({
    meta: {
        isGuest: true,
    }
})
</script>

<template>
  <LoginView />
</template>